import { ReactNode } from 'react'
import { cn } from '../../lib/utils'

// Titled card for grouped content (forms, settings blocks, widget groups). Do
// NOT wrap a page's MAIN table in a SectionCard — use TablePanel, which gives
// the table a full-height white panel without the double chrome. The exception
// is a SMALL table inside a dashboard/widget grid: `<SectionCard noBodyPadding>`
// + `<DataTable/>`.
export interface SectionCardProps {
  icon?: ReactNode
  title: ReactNode
  subtitle?: ReactNode
  action?: ReactNode
  children: ReactNode
  noBodyPadding?: boolean
  /** Stretch to fill the parent's height (a lone section = full screen). The
   *  parent must be a flex column; pass alongside `min-h-0 flex-1` if needed. */
  fill?: boolean
  className?: string
}

export function SectionCard({ icon, title, subtitle, action, children, noBodyPadding, fill, className }: SectionCardProps) {
  return (
    <section className={cn('overflow-hidden rounded-xl bg-card ring-1 ring-border', fill && 'flex min-h-0 flex-1 flex-col', className)}>
      <header className="flex shrink-0 items-center gap-2 border-b border-border px-5 py-3">
        {icon && <span className="text-muted-foreground">{icon}</span>}
        <h2 className="text-sm font-semibold text-foreground">{title}</h2>
        {subtitle && <span className="ml-1 text-[11px] text-muted-foreground">· {subtitle}</span>}
        {action && <div className="ml-auto">{action}</div>}
      </header>
      <div className={cn(noBodyPadding ? '' : 'p-5', fill && 'min-h-0 flex-1 overflow-y-auto')}>{children}</div>
    </section>
  )
}
